module.exports = __webpack_public_path__ + "fa2784318020002af30a8e8145603732.mp4";